import React, { useEffect, useState } from "react";
import { useDashboard } from "../context/DashboardContext";
import api from "../lib/api";
import ChartPanel from "../components/dashboard/ChartPanel";
import { PageHeader, ScoreBreakdown } from "../components/common/PageParts";
import ConfluenceRing from "../components/dashboard/ConfluenceRing";
import SwingSetupCard from "../components/dashboard/SwingSetupCard";
import AIMarketOutlook from "../components/dashboard/AIMarketOutlook";

export default function ChartAnalysis() {
  const { activeSymbol, interval, setIntervalTf, pairs, livePrices } = useDashboard();
  const [analysis, setAnalysis] = useState(null);
  const [swingHits, setSwingHits] = useState([]);
  const [lockedPlan, setLockedPlan] = useState(null);
  const activePair = pairs.find((p) => p.symbol === activeSymbol);

  useEffect(() => {
    let m = true;
    const load = () => api.getAnalysis(activeSymbol, interval).then((a) => m && setAnalysis(a)).catch(() => {});
    load();
    const t = setInterval(load, 15000);
    return () => { m = false; clearInterval(t); };
  }, [activeSymbol, interval]);

  useEffect(() => {
    let m = true;
    const load = () => api.getSwing(activeSymbol).then((d) => {
      if (!m) return;
      const s = d.active || (d.archived && d.archived[0]);
      setLockedPlan(d.active && d.active.entryLow != null ? d.active : null);
      const hits = (s?.progress?.targets || []).filter((x) => x.state === "HIT")
        .map((x) => ({ tp: x.tp, at: x.hitAt, price: x.hitPrice }));
      setSwingHits(hits);
    }).catch(() => {});
    load();
    const t = setInterval(load, 8000);
    return () => { m = false; clearInterval(t); };
  }, [activeSymbol]);

  return (
    <div className="ym-fade">
      <PageHeader title="Chart Analysis" subtitle={`${activeSymbol} · real OHLCV · EMA / RSI / ATR / S-R with live plan levels`} />
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
        <div className="xl:col-span-2">
          <ChartPanel symbol={activeSymbol} base={activePair?.base || activeSymbol.replace("USDT", "")} interval={interval} setInterval={setIntervalTf} analysis={analysis} lockedPlan={lockedPlan} livePrice={livePrices?.[activeSymbol]?.price} swingHits={swingHits} />
        </div>
        <div className="space-y-4">
          <SwingSetupCard symbol={activeSymbol} />
          <ConfluenceRing analysis={analysis} />
          <ScoreBreakdown analysis={analysis} />
        </div>
      </div>
      <AIMarketOutlook symbol={activeSymbol} />
    </div>
  );
}
